import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';
import { brandNeutralColors } from 'ui_system/compass/utils/theme';

export const breakpoints = [
  Theme.mobile.tinyMobileBreakpointWidth,
  Theme.mobile.phoneWidth,
];
export const mq = breakpoints.map((bp) => `@media (min-width: ${bp}px)`);

export const Background = styled.div`
  min-height: 100vh;
  background: white;

  /* Prevents app from being visible until partner styles loaded
  To prevent the 'flicker' as partner styles overwrite the base anyroad styles */
  visibility: ${(props) => (props.hidden ? 'hidden' : 'visible')};

  ${mq[1]} {
    background: ${(props) =>
      props.white ? 'white' : Theme.colors.lightBackground};
  }
`;

export const cssReset = ({
  fontFamily,
  fontSize,
  lineHeight,
  listStyle,
}) => css`
  /* 
   Adapted from:
   http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
  */

  html {
    font-family: ${fontFamily || '"Proxima-Nova", Helvetica, sans-serif'};
    ${fontSize && `font-size: ${fontSize};`}
    ${lineHeight && `line-height: ${lineHeight};`}
    color: ${brandNeutralColors.text.primary};
  }

  html,
  body,
  div,
  span,
  iframe,
  h1,
  h2,
  h3,
  p,
  input,
  a,
  img,
  strong,
  ol,
  ul,
  li,
  form,
  label,
  footer,
  header,
  nav,
  button,
  section {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    box-sizing: border-box;
  }

  h1,
  h2,
  h3 {
    font-weight: initial;
  }

  button,
  input {
    font-family: inherit;
    color: inherit;
    background-color: inherit;
  }

  footer,
  header,
  nav,
  section {
    display: block;
  }
  body {
    /* Stops scrollbar from affecting layout */
    width: 100vw;
    overflow-x: hidden;
  }
  ol,
  ul {
    ${listStyle && `list-style: ${listStyle};`}
    ${listStyle && `padding: 0 35px;`}
  }
  button {
    background-color: transparent;
    color: inherit;
    border-width: 0;
    padding: 0;
    cursor: pointer;
  }
  a {
    cursor: pointer;
    text-decoration: none;
  }

  /* Remove browser outlines except for keyboard users for accessibility */
  /* body:not(.keyboardUser) *:focus {
    outline: none;
  } */

  /* Native search input overrides */
  /* clears the 'X' from Internet Explorer */
  input[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  input[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  /* clears the 'X' from Chrome */
  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    display: none;
  }
`;
